import { TrackedChangeType } from 'prose-core'
import { stepTracker } from '../stepTracker'
import { isEmptyParagraph, isParagraph } from '../utils'
import { type TrackedChangesCommandHandler } from './types'
import { getTrackedChangesFromNode } from './utils'

export const splitBlock: TrackedChangesCommandHandler = ({ originalTr, wrappedTr, map, state, userId }): boolean => {
  const emptySelection = originalTr.selection.from === originalTr.selection.to
  const currentNode = originalTr.doc.nodeAt(originalTr.selection.from)
  const resolve = originalTr.doc.resolve(originalTr.selection.from)
  // The caret was at the very start of the text
  if (emptySelection && currentNode?.isText && resolve.textOffset === 0) {
    const depth = originalTr.selection.$from.depth
    const parentPos = originalTr.selection.$from.before(depth)
    const parentNode = originalTr.doc.nodeAt(parentPos)
    const nodeBeforePos = parentPos - 2
    const nodeBefore = parentPos > 2 ? originalTr.doc.nodeAt(nodeBeforePos) : null
    // The original command resulted in the paragraph right before being empty
    if (isParagraph(parentNode) && isParagraph(nodeBefore) && isEmptyParagraph(nodeBefore)) {
      const trackedChanges = getTrackedChangesFromNode(nodeBefore, TrackedChangeType.Insertion, userId)
      // We actually want the new paragraph, we just want it to get the trackedChange instead of the currentNode
      originalTr.steps.map((step) => wrappedTr.step(step))
      wrappedTr.setNodeMarkup(nodeBeforePos, nodeBefore.type, { ...nodeBefore.attrs, trackedChanges }, nodeBefore.marks)
      return true
    }
  }

  stepTracker({ originalTr, wrappedTr, map, state, userId })
  return true
}
